import { artifactTypeUrl } from "@helpers/constants";

export const artifactTypePaths = Object.values(artifactTypeUrl)
  .concat("artifact")
  .join("|");

export const meetingsRoutes = [
  "/calendar/user/:userId",
  "/calendar",
  "/meetings/:type/user/:userId",
  "/meetings/:type",
  "/meetings",
];
